import React, {useCallback, useEffect, useState} from "react";
import '@inovua/reactdatagrid-community/index.css'
import {euroFormat} from "../../utils/usefullFunctions";
import {useFormikContext} from "formik";
import {FormField} from "../forms";
import {Form} from "react-bootstrap";
import CustomDataGrid from "../table/CustomDataGrid";

const columns = [
    {name: 'name', header: 'Uurtarief', minWidth: 300, editable: false,},
    {
        name: 'cost', header: 'Kost', defaultFlex: 1, minWidth: 50, type: 'number',
        render: ({value}) => {
            if (value) return euroFormat(value)
        }

    },
    {
        name: 'margin', header: 'Marge', defaultFlex: 1, minWidth: 50, type: 'number',
        render: ({value}) => `${(value * 100).toFixed(2)}%`
    },
    {
        name: 'sale',
        header: 'Verkoop',
        defaultFlex: 1,
        minWidth: 50,
        type: 'number',
        editable: false,
        render: ({data}) => {
            if (data.cost && data.margin) return euroFormat(data.cost / (1 - data.margin))
        },
        onRender: (cellProps) => {
            cellProps.style.background = '#f8f8f8'
        }

    },
];

// Uurtarieven tab
const HourTariffs = () => {

    const {setFieldValue, values} = useFormikContext();
    const {service_form_project_hour_tariffs} = values
    const [dataSource, setDataSource] = useState([
        {
            id: 0,
            name: "BOA",
            cost: service_form_project_hour_tariffs.boa.cost,
            margin: service_form_project_hour_tariffs.boa.margin,
            sale: 0,
        },
        {
            id: 1,
            name: "OH",
            cost: service_form_project_hour_tariffs.oh.cost,
            margin: service_form_project_hour_tariffs.oh.margin,
            sale: 0,
        },
        {
            id: 2,
            name: "PL",
            cost: service_form_project_hour_tariffs.pl.cost,
            margin: service_form_project_hour_tariffs.pl.margin,
            sale: 0,
        },
    ]);

    // Sla veranderingen op in de context
    useEffect(() => {
        if (JSON.stringify(service_form_project_hour_tariffs) !== JSON.stringify({
            boa: {
                cost: dataSource[0].cost,
                margin: dataSource[0].margin
            },
            oh: {
                cost: dataSource[1].cost,
                margin: dataSource[1].margin
            },
            pl: {
                cost: dataSource[2].cost,
                margin: dataSource[2].margin
            }
        })) setDataSource([
            {
                id: 0,
                name: "BOA",
                cost: service_form_project_hour_tariffs.boa.cost,
                margin: service_form_project_hour_tariffs.boa.margin,
                sale: 0,
            },
            {
                id: 1,
                name: "OH",
                cost: service_form_project_hour_tariffs.oh.cost,
                margin: service_form_project_hour_tariffs.oh.margin,
                sale: 0,
            },
            {
                id: 2,
                name: "PL",
                cost: service_form_project_hour_tariffs.pl.cost,
                margin: service_form_project_hour_tariffs.pl.margin,
                sale: 0,
            },
        ])
    }, [service_form_project_hour_tariffs])

    useEffect(() => {
        setFieldValue("service_form_project_hour_tariffs", {
            boa: {
                cost: dataSource[0].cost,
                margin: dataSource[0].margin
            },
            oh: {
                cost: dataSource[1].cost,
                margin: dataSource[1].margin
            },
            pl: {
                cost: dataSource[2].cost,
                margin: dataSource[2].margin
            }
        })
        setFieldValue("service_form_project_data_tariffs", dataSource)
    }, [dataSource])

    const onEditComplete = useCallback(({value, columnId, rowId}) => {
        const data = [...dataSource];
        data[rowId][columnId] = parseFloat(value);
        setDataSource(data);
    }, [dataSource])

    return (<>
        <h4>
            Uurtarieven
        </h4>

            <CustomDataGrid
                columns={columns}
                dataSource={dataSource}
                onEditComplete={onEditComplete}
            />

        <Form.Label>Risico</Form.Label>
        <br/>
        <FormField name={"service_form_project_risc"}
                   style={{display: "inline", width: "5%"}}
                   className={"mb-3"}
                   control={"input"}
                   type={"number"}
                   min={0}
                   max={99}
        />%
    </>);
}


export default HourTariffs